import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { Route } from 'src/app/models/enums/Route.enum';
import { SharedService } from 'src/app/services/shared.service';
import { TermsAndConditionsService } from 'src/app/services/terms-and-conditions.service';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsGuard implements CanActivateChild {

  constructor(
    private readonly sharedService: SharedService,
    private readonly tecService: TermsAndConditionsService
  ) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    // Posso navigare solo sulle rotte della privacy policy e dei terms and conditions
    if (this.tecService.isTermsAndConditionConfirmed()) {
      return true;
    }
    let nextRoute = childRoute.routeConfig?.path;
    let allowedChildRoutes: string[] = [Route.HomePage, Route.PrivacyPolicy, Route.TermsAndConditions];
    if (allowedChildRoutes.includes(nextRoute || '')) {
      return true;
    }
    this.sharedService.navigateTo_MainPage();
    return false;
  }

}
